import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";
import { ReactComponent as QuotesLeftIcon } from "../../images/quotes-l.svg";
import { ReactComponent as QuotesRightIcon } from "../../images/quotes-r.svg";
import { ReactComponent as ArrowLeftIcon } from "../../images/arrow-left-2-icon.svg";
import { ReactComponent as ArrowRightIcon } from "../../images/arrow-right-2-icon.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "../../images/svg-decorator-blob-4.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "../../images/svg-decorator-blob-5.svg";
import GlobalStyles from "styles/GlobalStyles"; // ✅ Importing custom font styles

import "slick-carousel/slick/slick.css";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-sm`;

const TestimonialSliderContainer = tw.div`mt-24`;
const TestimonialSlider = styled(Slider)``;
const Testimonial = tw.div`flex! flex-col items-center md:items-stretch md:flex-row md:justify-center outline-none`;

const ImageContainer = styled.div`
  ${tw`md:mx-3 lg:mx-6 w-2/3 md:w-4/12 rounded flex items-center max-w-xs md:max-w-none`}
  img {
    ${tw`rounded`}
  }
`;

const TextContainer = tw.div`md:mx-3 lg:mx-6 md:w-6/12 py-4 flex flex-col justify-between`;

const QuoteContainer = tw.div`relative p-6 md:p-8 lg:p-10 mt-4 md:mt-0`;

const Quote = styled.blockquote`
  ${tw`text-right font-medium text-xl lg:text-2xl xl:text-3xl`}
  font-family: 'CustomFont', serif;
  white-space: pre-line;
`;

const CustomerInfo = tw.div`px-5 lg:px-10 text-center md:text-left mt-4 md:mt-0`;

const CustomerName = styled.h5`
  ${tw`font-bold text-lg lg:text-xl xl:text-2xl text-primary-500`}
  font-family: 'CustomFont', serif;
`;

const CustomerTitle = styled.p`
  ${tw`font-medium text-sm text-right`}
  font-family: 'CustomFont', serif;
`;

const QuotesLeft = tw(
  QuotesLeftIcon
)`w-8 h-8 lg:w-10 lg:h-10 text-primary-500 absolute top-0 left-0`;
const QuotesRight = tw(
  QuotesRightIcon
)`w-8 h-8 lg:w-10 lg:h-10 text-primary-500 absolute bottom-0 right-0`;

const SliderControlButtonContainer = styled.div`
  ${tw`absolute top-0 h-full flex items-end md:items-center z-20`}
  button {
    ${tw`text-secondary-500 hover:text-primary-500 focus:outline-none transition duration-300 transform hover:scale-125 transform -translate-y-2/3 md:translate-y-0`}
    svg {
      ${tw`w-8`}
    }
  }
`;

const NextArrow = ({ currentSlide, slideCount, ...props }) => (
  <SliderControlButtonContainer tw="right-0">
    <button {...props}>
      <ArrowRightIcon />
    </button>
  </SliderControlButtonContainer>
);

const PreviousArrow = ({ currentSlide, slideCount, ...props }) => (
  <SliderControlButtonContainer tw="left-0">
    <button {...props}>
      <ArrowLeftIcon />
    </button>
  </SliderControlButtonContainer>
);

const DecoratorBlob1 = tw(
  SvgDecoratorBlob1
)`absolute w-32 top-0 left-0 -z-10 text-primary-500 opacity-25 transform -translate-x-full`;
const DecoratorBlob2 = tw(
  SvgDecoratorBlob2
)`absolute w-32 bottom-0 right-0 -z-10 text-pink-500 opacity-15 transform translate-x-2/3 translate-y-8`;

const formattedQuote = `      quote: \`
تاریخ پیدائش: ۷ جون ۱۹۵۸ء

جائے ولادت: باہر پیٹ رائید رگ ضلع اننت پور، آندھرا پردیش ۔ جنوبی ہند

علیمی صلاحیت: تعلم منشی فاضل ، S.V یونیورسٹی، عالم و فاضل جامعہ محمد یہ را ئیدرگ ۔ اننت پور۔ آندھرا

فراغت: ۱۹۷۴ء

جماعتی خدمات:
  ۱۹۸۸ ء - ناظم جمعیت شبان اہل حدیث کرنا ٹک
  ۱۹۹۰ء تا ۲۰۰۲ ء - ناظم اعلیٰ صوبائی جمعیت اہل حدیث کرنا ٹک
  ۱۹۹۳ ء تا ۱۹۹۷ ء - نائب ناظم مرکزی جمعیت اہل حدیث ہند برائے جنوبی ہند
  ۱۹۹۷ء تا حال - نائب ناظم مرکزی جمعیت اہل حدیث ہند
  ۲۰۱۶ء سے تا حال - امیر صوبائی جمعیت اہل حدیث کرنا تک و گوا

تألیفات:
  • تحریک اہل حدیث کرنا تک کی سرگرمیاں
  • نقوش تابنده، سوانح مولانا سید اسماعیل سلفی، بانی جامعہ محمد یہ رائید رگ ۔ آندھرا
  • تاریخ اہل حدیث جنوبی ہند کے درخشاں پہلو
  • کرناٹک میں جماعت اہل حدیث کا ارتقاء ایک جائزہ (زیر ترتیب)

تعلیمی اداروں کا قیام:
مولانا عبدالوہاب عبد العزیز جامعی نے ۲۰۰۱ء میں "الجمعية التعليمية والخيرية للاقلية المسلمة" کے نام سے ایک تعلیمی ادارہ قائم کیا اور خون جگر سے اس کی آبیاری کی۔ چند سالوں کی محنت کے نتیجے میں کلیہ فاطمہ الزہراء للبنات اور اس سے ملحق اداروں سے علم کا ایک شاداب چمن معرض وجودمیں آگیا۔

مؤسسات:
  • کلیہ فاطمتہ الزہرا الاسلامیہ للبنات
  • کلیہ عائشہ (للنساء)
  • فاطمہ پرائمری اسکول
  • فاطمہ ہائی اسکول
  • مدرسہ دار الحدیث
  • مدرسہ خدیجة الکبری
  • رائل پبلک انگلش میڈیم اسکول

علم کی ایک بستی آباد ہوگئی جسے دیکھ کر دل و نظر کو روحانی انبساط حاصل ہوتا ہے۔ مولانا عبدالوہاب جامعی کا نام جد و جہد کی ایک پہچان بن گیا۔

ماخوذ از: گلستان حدیث مولانا محمد اسحاق بھٹی ص ۳۷۸، ترتیب مولانا انور سلفی کویت
      \`,`;

export default function TestimonialSection() {
  const testimonials = [
    {
      imageSrc: require("../../images/Alumni/AbdulWahabJamai.png"),
      quote: `تاریخ پیدائش: ۷ جون ۱۹۵۸ء

جائے ولادت: باہر پیٹ رائید رگ ضلع اننت پور، آندھرا پردیش ۔ جنوبی ہند

علیمی صلاحیت: تعلم منشی فاضل ، S.V یونیورسٹی، عالم و فاضل جامعہ محمد یہ را ئیدرگ ۔ اننت پور۔ آندھرا

فراغت: ۱۹۷۴ء

جماعتی خدمات:
  ۱۹۸۸ ء - ناظم جمعیت شبان اہل حدیث کرنا ٹک
  ۱۹۹۰ء تا ۲۰۰۲ ء - ناظم اعلیٰ صوبائی جمعیت اہل حدیث کرنا ٹک
  ۱۹۹۳ ء تا ۱۹۹۷ ء - نائب ناظم مرکزی جمعیت اہل حدیث ہند برائے جنوبی ہند
  ۱۹۹۷ء تا حال - نائب ناظم مرکزی جمعیت اہل حدیث ہند
  ۲۰۱۶ء سے تا حال - امیر صوبائی جمعیت اہل حدیث کرنا تک و گوا

تألیفات:
  • تحریک اہل حدیث کرنا تک کی سرگرمیاں
  • نقوش تابنده، سوانح مولانا سید اسماعیل سلفی، بانی جامعہ محمد یہ رائید رگ ۔ آندھرا
  • تاریخ اہل حدیث جنوبی ہند کے درخشاں پہلو
  • کرناٹک میں جماعت اہل حدیث کا ارتقاء ایک جائزہ (زیر ترتیب)

تعلیمی اداروں کا قیام:
مولانا عبدالوہاب عبد العزیز جامعی نے ۲۰۰۱ء میں "الجمعية التعليمية والخيرية للاقلية المسلمة" کے نام سے ایک تعلیمی ادارہ قائم کیا اور خون جگر سے اس کی آبیاری کی۔ چند سالوں کی محنت کے نتیجے میں کلیہ فاطمہ الزہراء للبنات اور اس سے ملحق اداروں سے علم کا ایک شاداب چمن معرض وجودمیں آگیا۔

مؤسسات:
  • کلیہ فاطمتہ الزہرا الاسلامیہ للبنات
  • کلیہ عائشہ (للنساء)
  • فاطمہ پرائمری اسکول
  • فاطمہ ہائی اسکول
  • مدرسہ دار الحدیث
  • مدرسہ خدیجة الکبری
  • رائل پبلک انگلش میڈیم اسکول

علم کی ایک بستی آباد ہوگئی جسے دیکھ کر دل و نظر کو روحانی انبساط حاصل ہوتا ہے۔ مولانا عبدالوہاب جامعی کا نام جد و جہد کی ایک پہچان بن گیا۔

ماخوذ از: گلستان حدیث مولانا محمد اسحاق بھٹی ص ۳۷۸، ترتیب مولانا انور سلفی کویت`,
      customerName: "شیخ عبد الوہاب عبد العزیز جامعی",
      //customerTitle: "CEO, Delos Inc.",
    },
    // {
    //   imageSrc:
    //     "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2.25&w=512&h=512&q=80",
    //   quote:
    //     "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit.",
    //   customerName: "Adam Cuppy",
    //   customerTitle: "Founder, EventsNYC",
    // },
    // {
    //   imageSrc:
    //     "https://images.unsplash.com/photo-1580852300654-03c803a14e24?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=4.25&w=512&h=512&q=80",
    //   quote:
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla convallis egestas rhoncus.",
    //   customerName: "Steven Marcetti",
    //   customerTitle: "Event Manager, Brite",
    // },
  ];

  return (
    <>
      <GlobalStyles />
      <Container>
        <Content>
          <HeadingInfoContainer>
            <HeadingTitle>Alumni Stories</HeadingTitle>
            <HeadingDescription></HeadingDescription>
          </HeadingInfoContainer>
          <TestimonialSliderContainer>
            <TestimonialSlider
              nextArrow={<NextArrow />}
              prevArrow={<PreviousArrow />}
            >
              {testimonials.map((testimonial, index) => (
                <Testimonial key={index}>
                  <ImageContainer>
                    <img
                      src={testimonial.imageSrc}
                      alt={testimonial.customerName}
                    />
                  </ImageContainer>
                  <TextContainer>
                    <QuoteContainer>
                      <QuotesLeft />
                      <Quote>{testimonial.quote}</Quote>
                      <QuotesRight />
                    </QuoteContainer>
                    <CustomerInfo>
                      <CustomerName>{testimonial.customerName}</CustomerName>
                      <CustomerTitle>{testimonial.customerTitle}</CustomerTitle>
                    </CustomerInfo>
                  </TextContainer>
                </Testimonial>
              ))}
            </TestimonialSlider>
          </TestimonialSliderContainer>
        </Content>
        <DecoratorBlob1 />
        <DecoratorBlob2 />
      </Container>
    </>
  );
}
